/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Window { 
    totalCalls?: number;
    missedPercent?: number;
    conversionPercent?: number;
    revenue?: number;
    avgCheck?: number;
    avgScore?: number;
    negativePercent?: number;
    answerP90Seconds?: number;
}

